module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gdxx"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', [_c('p', [_c('b', [_vm._v("股东名称：")]), _vm._v(" " + _vm._s(item.GDMC) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("持股比例\t：")]), _vm._v(" " + _vm._s(item.CGBL) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("入股时间：")]), _vm._v(" " + _vm._s(item.RGSJ) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("法定代表人：")]), _vm._v(" " + _vm._s(item.FR) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("办公地址\t：")]), _vm._v(" " + _vm._s(item.BGDZ) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("公司网址：")]), _vm._v(" " + _vm._s(item.GSWZ) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("所属行业：")]), _vm._v(" " + _vm._s(item.SSHY) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("经济类型：")]), _vm._v(" " + _vm._s(item.JJLX) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("备注：")]), _vm._v(" " + _vm._s(item.BZ) + " ")]), _vm._v(" "), (_vm.list.length > 1) ? _c('div', {
      staticClass: "line"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "margin-b"
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63600f82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xxgs/nr/gdxx.vue
// module id = 830
// module chunks = 2